import * as React from 'react'
import { BPMChart } from '../../../../components/Chart'
import { BPMAnalyticsAPI } from '../../../../api'

export const BPMGroupChart: React.FunctionComponent = (props) => {
    return (
        <BPMChart {...props} title='BPM Groups' subTitle='By Downloads' type='doughnut'
            onRequestLoad={(options, signal) => {
                return (BPMAnalyticsAPI.get<any>('downloads/bpm', options, signal))
            }} allowedTypes={['spline', 'bar', 'doughnut', 'pie', 'tree']}
            series={{ name: 'Downloads', valueField: 'count', argumentField: 'bpm' }}>
        </BPMChart>
    )
}


// WEBPACK FOOTER //
// ./src/pages/Statistics/Downloads/charts/BPMGroupChart.tsx